/** Two letters for an avatar: initials where we have them, else the email. */
export function initials(firstName: string | null, lastName: string | null, email: string): string {
  const named = `${firstName ?? ''}${lastName ?? ''}`.trim();
  const letters = named ? `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}` : email.slice(0, 2);
  return letters.toUpperCase();
}

/** "Rana Haddad", falling back to the email when no name is on the record. */
export const displayName = (
  firstName: string | null,
  lastName: string | null,
  email: string,
): string => [firstName, lastName].filter(Boolean).join(' ') || email;
